import React from 'react';

import {ROLES} from './Menu';

interface Props {
  children: React.ReactElement;
  _role: string;
}

/**
 * MenuContentWrapper is a wrapper that can be placed within a Menu to wrap the content.  This can be used to
 * allow you to place a component wrapping other Menu contents.
 *
 * The Menu is very strict and only allows a known set of components as its direct children.  This wrapper
 * is used to designate that you're breaking the pattern will be nesting menu children underneath other
 * components in order to create reusable sets of menu options.
 *
 * You still should not render anything other then Menu children (Section, SectionHeader, Footer,
 * FooterOption, Option) within a MenuContentWrapper.
 *
 * Note that by using this component, it will not render any additional submenus.  Options with submenus must
 * be a direct child of a Menu or Section.
 *
 * @example You can use this component to wrap a custom component that you want to place within a Menu.
 * const MyReusableMenuOptionComponent = ()=>(
 *   <>
 *      <Option/>
 *      <Option/>
 *      <Option/>
 *   </>
 * );
 *
 * <Menu>
 *  <Option/>
 *  <Option/>
 *  <MenuContentWrapper>
 *     <MyReusableMenuOptionComponent/>
 *  <MenuContentWrapper>
 * </Menu>
 */
// eslint-disable-next-line react/prefer-stateless-function -- using a class component in order to preserve _role on defaultProps
export default class MenuContentWrapper extends React.Component<Props> {
  static defaultProps = {
    _role: ROLES.WRAPPER,
  };

  override render(): JSX.Element {
    return this.props.children;
  }
}
